import React, { Component } from "react";
import { push } from "react-router-redux";
import classnames from "classnames";
import { TiWarningOutline } from "react-icons/ti";
import _ from "i18n";

import { getMonthName } from "Utils";
import { setFilterCollaborators, setSelectedCollaboratorName } from "Actions";

import { StandardBarChart } from "../Common/Charts/StandardBarChart";
import CapacityPlaningMonthDetails from "./CapacityPlaningMonthDetails";
import CapacityPlaningChartFetching from "./CapacityPlaningChartFetching";

import CapacityPlaningApi from "../../services/capacityPlaningServices";
import styles from "./CollaboratorSpace.local.scss";

class CollaboratorCapacityPlaningChart extends Component {
  constructor(props) {
    super(props);

    let monthName = getMonthName(new Date().getMonth() + 1);
    this.state = {
      monthState: [],
      month: monthName,
      day: null,
      isCumulate: 0,
      loading: true,
      error: false,
      chartData: null
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { period, year, date } = this.props;
    if (
      prevProps.period !== period ||
      prevProps.year !== year ||
      prevProps.date !== date
    ) {
      if (period === "CURRENT") {
        let monthName = getMonthName(new Date().getMonth() + 1);
        this.setState({ month: monthName, isCumulate: 1 });
      }
      setTimeout(() => this.fetchCapacityPlaningChartData(), 200);
    }
  }

  componentDidMount() {
    this.fetchCapacityPlaningChartData();
  }

  handleRedirectCapacityPlaning = () => {
    const { user, dispatch } = this.props;
    let collaboratorName = user.firstName + " " + user.lastName;

    dispatch(
      setFilterCollaborators([
        { value: 1, label: collaboratorName, color: "#000000" }
      ])
    );
    dispatch(setSelectedCollaboratorName(collaboratorName));

    dispatch(push(`/calendar/${collaboratorName}/${user.id}`));
  };

  fetchCapacityPlaningChartData = () => {
    const { user, organization, period, year, date } = this.props;
    const { isCumulate, month } = this.state;
    this.setState({ loading: true });
    CapacityPlaningApi.getCapacityPlaningCollaboratorChart(
      organization.id,
      user.uid,
      user.adminisId,
      period,
      year,
      isCumulate,
      date
    )
      .then(response => {
        this.setState({
          chartData: response,
          error: false,
          day: period === "MONTHLY" && Object.keys(response["monthDetails"])[0],
          monthState:
            period === "MONTHLY"
              ? response["monthDetails"][
                  Object.keys(response["monthDetails"])[0]
                ]
              : response["monthDetails"][month],
          loading: false
        });
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
  };

  handleChangeDayState = day => {
    let { chartData } = this.state;

    this.setState({
      monthState: chartData["monthDetails"][day],
      day: day
    });
  };

  handleChangeMonthState = month => {
    let { chartData } = this.state;

    this.setState({
      monthState: chartData["monthDetails"][month],
      month: month
    });
  };

  handleChangeCumulateFilter = isCumulate => {
    this.setState({
      isCumulate
    });

    setTimeout(() => this.fetchCapacityPlaningChartData(), 200);
  };

  render() {
    let {
      monthState,
      month,
      isCumulate,
      loading,
      chartData,
      error,
      day
    } = this.state;

    return (
      <div className={styles.capacity_planing_container}>
        <div className={styles.capacity_planing_div_header}>
          <div className={styles.capacity_planing_div_label}>
            <div>{_("capacityPlaning")}</div>
          </div>
          <div className={styles.explorer_btn}>
            <div
              style={{ padding: "5% 0% 0% 17%" }}
              //onClick={() => this.handleRedirectCapacityPlaning()}
            >
              {_("Explorer")}
            </div>
          </div>
        </div>
        <div className={classnames("row medium-12", styles.cumulate_filter)}>
          <div
            key={1}
            className={classnames("columns medium-6 small-6")}
            style={{
              color: isCumulate === 1 ? "#29394D" : "#B2BCC6"
            }}
            onClick={() => this.handleChangeCumulateFilter(1)}
          >
            <div style={{ paddingLeft: "75%", marginBottom: "1%" }}>
              {_("cumulate")}
            </div>
            <div style={{ paddingLeft: "60%" }}>
              <div
                className={styles.cumulate_filter_div}
                style={{
                  background: isCumulate === 1 ? "#29394D" : "#B2BCC6"
                }}
              />
            </div>
          </div>

          <div
            key={2}
            className={classnames("columns medium-6 small-6")}
            style={{
              color: isCumulate === 1 ? "#B2BCC6" : "#29394D"
            }}
            onClick={() => this.handleChangeCumulateFilter(0)}
          >
            <div style={{ paddingLeft: "12%", marginBottom: "1%" }}>
              {_("nonCumulated")}
            </div>
            <div>
              <div
                className={styles.cumulate_filter_div}
                style={{
                  background: isCumulate === 1 ? "#B2BCC6" : "#29394D"
                }}
              />
            </div>
          </div>
        </div>
        {loading ? (
          <CapacityPlaningChartFetching />
        ) : error ? (
          <div className={styles.error_frame}>
            <TiWarningOutline />
            <span>Oups</span>
          </div>
        ) : (
          <div>
            {chartData && (
              <span>
                <StandardBarChart
                  chartData={Object.values(chartData.data)}
                  dataKeysY={chartData.accounts.map(({ code }) => code)}
                  dataKeyX={this.props.period === "MONTHLY" ? "day" : "month"}
                  currency={chartData.accounts[0].unit === "H"}
                  legendLabels={chartData.accounts.map(({ label }) => _(label))}
                  showLabels={false}
                  month={month}
                  day={day}
                  period={this.props.period}
                  handleChangeMonthState={this.handleChangeMonthState}
                  handleChangeDayState={this.handleChangeDayState}
                  containerHeight={300}
                  tooltipValueFormat={"H"}
                />
                <div>
                  <CapacityPlaningMonthDetails monthState={monthState} />
                </div>
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default CollaboratorCapacityPlaningChart;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorCapacityPlaningChart.js